var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEqual = function SvgEqual(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M2.277 9.012c-.333.117-.372.519-.067.677l.097.05h19.387l.097-.05c.269-.14.28-.472.019-.633l-.089-.055-9.697-.003C5.68 8.996 2.31 9 2.277 9.012m-.044 6.29c-.292.133-.314.473-.042.64l.088.055h19.442l.089-.054c.27-.168.248-.508-.042-.642l-.11-.05H2.343z",
    clipRule: "evenodd"
  })));
};
export default SvgEqual;